import React from "react";
import { useLocalFileData } from "@/hooks/ai-tool-process/use-local-file-data";
import AudioFileInput from "@/components/common/audio-file-input";
import { LicenseName } from "@/data/license.data";
import { ConvertBaseSettings } from "@/hooks/ai-tool-process/use-convert-base-context-provider";
import { ConvertBaseContextBuilder } from "@/components/common/convert-base/convert-base-context-builder";

export interface LocalFileInputProps {
  license: LicenseName;
  isLimited: boolean;
}

export interface ConvertBaseLocalFileInputProps {
  localFileInputProps: LocalFileInputProps;
}

const LocalFileInput = ({
  localFileInputProps,
}: ConvertBaseLocalFileInputProps) => {
  const inputProps = useLocalFileData();

  return (
    <AudioFileInput
      isLimited={localFileInputProps.isLimited}
      license={localFileInputProps.license}
      {...inputProps}
    />
  );
};

export default LocalFileInput;
